module.exports = __webpack_public_path__ + "img/face12.58354d04.gif";